/**
 * File lightbox.js
 * Adds lightbox to WordPress gallery blocks.
 */

import GLightbox from 'glightbox';
// eslint-disable-next-line @babel/new-cap
const lightbox = GLightbox({
    selector: 'data-glightbox',
});

document.querySelectorAll('.gallery__item img, .gallery__item video').forEach(function (item, i) {
    let src = item.getAttribute("src");
    if (item.nodeName === 'IMG' && item.hasAttribute("srcset")) {
        const srcset = item.getAttribute("srcset").split(", ");
        if (srcset.length > 0) {
            src = srcset[srcset.length - 1].split(" ")[0];
        }
    } else if (item.nodeName === 'VIDEO') {
        src = item.querySelector('source').getAttribute('src');
    }

    const href = document.createElement("a");
    href.setAttribute("href", src);
    href.setAttribute("data-gallery", `gallery-0`);
    if (item.nodeName === 'IMG') {
        href.setAttribute("data-glightbox", 'type: image');
    } else {
        href.setAttribute("data-glightbox", 'type: video');
    }

    item.parentNode.insertBefore(href, item);
    href.appendChild(item);
});

lightbox.reload();
